import { createContext } from 'react';

const MarineMonitoringState = createContext();

export default MarineMonitoringState;
